import { BarChart3, Boxes, ClipboardCheck, Database, Globe2, History, ListTodo, LogOut, Package, ShieldCheck, Table2, TrendingUp, ScanSearch } from "lucide-react";
import { Fragment } from "react";
import type { AccessContext } from "../types";

export type AppSection = "sales" | "catalog" | "deals" | "sources" | "market-value" | "lead-checker" | "quality" | "price-history" | "inventory";

const icons = { sales: Table2, catalog: Package, deals: ListTodo, sources: Globe2, "market-value": TrendingUp, "lead-checker": ScanSearch, quality: ClipboardCheck, "price-history": History, inventory: Boxes };

export function AppShell({
  access,
  section,
  onNavigate,
  onLogout,
  children
}: {
  access: AccessContext;
  section: AppSection;
  onNavigate: (section: AppSection, href: string) => void;
  onLogout: () => void;
  children: React.ReactNode;
}) {
  return <div className="app-shell">
    <aside className="sidebar">
      <div className="brand">
        <span className="brand-mark">G</span>
        <span><strong>Grafit</strong><em>OS</em></span>
      </div>
      <div className="nav-label">Рабочая область</div>
      <nav aria-label="Основная навигация">
        {access.navigation.map((item, index) => {
          const itemSection = item.key as AppSection;
          const active = itemSection === section;
          const Icon = icons[itemSection];
          return <Fragment key={item.key}>
            {item.planned && !access.navigation[index - 1]?.planned && <div className="nav-future-label">В разработке</div>}
            <a
            key={item.key}
            className={`nav-link${active ? " active" : ""}`}
            href={item.href}
            aria-current={active ? "page" : undefined}
            onClick={event => {
              event.preventDefault();
              onNavigate(itemSection, item.href);
            }}
          >
            <Icon size={18} />
            <span>{item.label}</span>
            {item.planned && <span className="nav-planned-dot" title="В разработке" />}
          </a></Fragment>;
        })}
      </nav>
      <div className="sidebar-spacer" />
      <div className="data-source-card">
        <Database size={18} />
        <span><strong>Источник данных</strong><small>Сохранённые данные · только чтение</small></span>
      </div>
    </aside>

    <div className="main-shell">
      <header className="topbar">
        <div className="topbar-context">
          {section === "sales" ? <BarChart3 size={17} /> : (() => { const Icon = icons[section]; return <Icon size={17} />; })()}
          <span>{access.navigation.find(item => item.key === section)?.label}</span>
        </div>
        <div className="topbar-actions">
        <div className="role-pill" title={`Права: ${access.permissions.join(", ")}`}>
          <ShieldCheck size={15} />
          <span>{access.user.username} · {access.user.role === "sales" ? "Сотрудник продаж" : "Администратор"}</span>
        </div>
        <button className="logout-button" type="button" onClick={onLogout}><LogOut size={15} />Выйти</button>
        </div>
      </header>
      <main className="content">{children}</main>
    </div>
  </div>;
}
